import App             from './App';
import i18n            from 'i18next';
import React           from 'react';
import values          from './panel/values';
import Cookies         from 'js-cookie';
import ReactDOM        from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter    } from 'react-router-dom';
import { initReactI18next } from 'react-i18next';

import enTranslation from './translation/en.json';
import faTranslation from './translation/fa.json';
import trTranslation from './translation/tr.json';

import './index.scss';

const lng = Cookies.get('lng');

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    fa: { translation: faTranslation },
    tr: { translation: trTranslation },
  },
  lng: lng ? lng : 'fa',
  fallbackLng: 'fa',
  interpolation: { escapeValue: false },
});

document.title = values.constants.TITLE;

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
